import type { SlideShowItem } from '@/models/types/application/slide-show-item'
import type { FetchOptionsType } from './api'
import { getRequest } from './make-request'

type ApplicationCrudType = (fetchOptions?: FetchOptionsType) => {
    getSlides: () => Promise<SlideShowItem[]>
}

const APPLICATION_URL =
    typeof window === 'undefined'
        ? `${process.env.API_URL}/api/v1/Applicazione/SlidesShow`
        : `${location.origin}/api/v1/Applicazione/SlidesShow`
const APPLICATION_TAG = 'Application'
const SLIDES_TAG = 'Slides'

const applicationCrud: ApplicationCrudType = (fetchOptions) => ({
    getSlides: async () => {
        const url = new URL(APPLICATION_URL)
        const slides = await getRequest<SlideShowItem[]>({
            url,
            next: { tags: [APPLICATION_TAG, SLIDES_TAG] },
            ...fetchOptions,
        })
        return slides
    },
})

export { APPLICATION_TAG, applicationCrud, SLIDES_TAG, type ApplicationCrudType, type SlideShowItem }
